export const FEATURE_FLAGS = [
  {
    key: 'PUBLIC_PRIVATE_OVERRIDE' as const,
    desc: 'Show control to override public/private on incident locations'
  },
]satisfies readonly { key: string, desc: string }[]
